/**
 * Utilitário de refresh de token agnóstico
 * Centraliza o refresh independente do provider (Azure/Keycloak)
 */

import logger from '@/shared/lib/logger';

type TokenRefreshFunction = () => Promise<string | null>;

let refreshFunction: TokenRefreshFunction | null = null;

/** Registra a função de refresh do provider ativo */
export const registerTokenRefresh = (fn: TokenRefreshFunction): void => {
  refreshFunction = fn;
  logger.debug('[TokenRefresh] Função de refresh registrada');
};

/** Tenta renovar o token usando o provider registrado */
export const refreshAccessToken = async (): Promise<string | null> => {
  if (!refreshFunction) {
    logger.warn('[TokenRefresh] Nenhuma função de refresh registrada');
    return null;
  }

  try {
    logger.debug('[TokenRefresh] Tentando renovar token...');
    const newToken = await refreshFunction();
    
    if (newToken) {
      logger.info('[TokenRefresh] Token renovado com sucesso', {
        tokenLength: newToken.length,
      });
      return newToken;
    }
    
    logger.warn('[TokenRefresh] Refresh retornou null');
    return null;
  } catch (error) {
    logger.error('[TokenRefresh] Falha ao renovar token', {
      error: error instanceof Error ? error.message : String(error),
    });
    return null;
  }
};

/** Limpa a função de refresh registrada (chamado no logout) */
export const clearTokenRefresh = (): void => {
  refreshFunction = null;
  logger.debug('[TokenRefresh] Função de refresh limpa');
};
